<template>
  <transition name="fade2">
    <Loading v-if="!isLoadComplete" />
  </transition>
  <transition name="fade2">
    <Loading2 v-if="isLoadComplete2" />
  </transition>
  <Header />
  <div class="wrapper active">
    <router-view />
    <Footer />
  </div>
  <transition name="right">
    <Help v-if="shouldShowHelpPopup" />
  </transition>
  <transition name="fade">
    <No2 v-if="shouldShowTopPanel4" />
  </transition>
  <transition name="fade">
    <No3 v-if="shouldShowTopPanel5" />
  </transition>
</template>

<script lang="ts">
import { defineComponent, ref, reactive, computed, onMounted } from 'vue'
import IScroll from 'iscroll'
import dayjs from 'dayjs'
import 'dayjs/locale/ja'
import { useApplicationStore } from '@/store/modules/applicationModule'
import { Loading, Loading2 } from '@/components/presentational/organisms/'
import { Header, Help, Footer, No2, No3 } from '@/components/container'

dayjs.locale('ja')

interface State {
  iScrollObj: null | IScroll
}

export default defineComponent({
  name: 'App',
  components: {
    Header,
    Help,
    Loading,
    Loading2,
    Footer,
    No2,
    No3
  },
  setup() {
    const ApplicationStore = useApplicationStore()

    const root = ref(null)
    const state = reactive<State>({
      iScrollObj: null,
    })

    /** 一旦削除 */
    window.sessionStorage.removeItem('isCurrentPage')

    const errorDetail = computed(() => ApplicationStore.ErrorDetail)
    const shouldShowHelpPopup = computed(() => ApplicationStore.getShouldShowHelpPopup)
    const shouldShowTopPanel4 = computed(() => ApplicationStore.getShouldShowTopPanel4)
    const shouldShowTopPanel5 = computed(() => ApplicationStore.getShouldShowTopPanel5)

    const isLoadComplete = computed(() => ApplicationStore.isLoadComplete)
     const isLoadComplete2 = computed(() => ApplicationStore.isLoadComplete2)

    /** 初回データ読み込み */
    const loadData = async () => {
      try {
        ApplicationStore.isLoadComplete = false

        /** 現在時刻を設定する */
        const nowDate = dayjs()
        const expDate = nowDate.format('YYYY-MM-DD')
      } finally {
        console.log('complete')
      }
    }

    loadData()

    const onTapErrorClose = () => {
      ApplicationStore.UPD_ERROR_DETAIL()
    }



    return { state, root, errorDetail, onTapErrorClose, shouldShowHelpPopup, isLoadComplete, isLoadComplete2, shouldShowTopPanel4, shouldShowTopPanel5 }
  },
})
</script>

<style lang="scss">
@import './assets/css/reset.css';
@import './assets/css/default.scss';
@import './assets/css/helper.scss';
@import './assets/css/transition.scss';

.app-wrapper {
  position: relative;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  // transform: translate3d(0, 0, 0);
  // overflow: hidden;
}

.v-enter-to {
  transform: translateX(100vw) translateX(0px);
}

.v-enter-from {
  transform: translate(0px, 0px);
  transition: transform 225ms cubic-bezier(0, 0, 0.2, 1) 1ms;
}

.v-leave-to {
  transform: translateX(100vw) translateX(0px);
}

.v-leave-from {
  transform: translate(0px, 0px);
  transition: transform 225ms cubic-bezier(0, 0, 0.2, 1) 1ms;
}

.wrapper.active {
  transform: none !important;
  overflow-x: hidden;
}

.left-enter-active,
.left-leave-active {
  transform: translate(0px, 0px);
  transition: transform 825ms cubic-bezier(0, 0, 0.2, 1) 0ms;
}

.left-enter,
.left-leave-to {
  transform: translateX(-100vw) translateX(0px);
}

.fade2-enter-active,
.fade2-leave-active {
  will-change: opacity;
  transition: opacity 825ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
}

.fade2-enter,
.fade2-leave-to {
  opacity: 0;
}

.right-enter-active,
.right-leave-active {
  transform: translate(0px, 0px);
  transition: transform 225ms cubic-bezier(0, 0, 0.2, 1) 0ms;
}

.right-enter-from,
.right-leave-to {
  transform: translateX(100vw) translateX(0px);
}
</style>
